export default __webpack_public_path__ + "static/media/pill.ab615724.png";